import { z } from 'zod';

export const LEGACY_SPOT_CASH_RANGE = { minCents: 50000, maxCents: 300000 } as const;
export const SpotCashRangeSchema = z
  .object({
    minCents: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
    maxCents: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
  })
  .strict()
  .refine((range) => range.maxCents >= range.minCents);
export type SpotCashRange = z.infer<typeof SpotCashRangeSchema>;
export const SpotApprovalModeSchema = z.enum(['committee_only', 'committee_then_supervisor']);
export type SpotApprovalMode = z.infer<typeof SpotApprovalModeSchema>;
/** The Spot Committee's members: each once, at most 100 (APP-102). */
export const SpotCommitteeSchema = z
  .array(z.uuid().transform((id) => id.toLowerCase()))
  .max(100)
  .refine((ids) => new Set(ids).size === ids.length);
export const SpotWorkflowConfigSchema = z
  .object({
    committeeIds: SpotCommitteeSchema,
    approvalMode: SpotApprovalModeSchema,
    cashRange: SpotCashRangeSchema,
  })
  .strict();
export type SpotWorkflowConfig = z.infer<typeof SpotWorkflowConfigSchema>;
export const SpotReviewPolicySchema = z
  .object({
    approvalMode: SpotApprovalModeSchema,
    cashRange: SpotCashRangeSchema,
    settingRowId: z.uuid().nullable(),
  })
  .strict();
export type SpotReviewPolicy = z.infer<typeof SpotReviewPolicySchema>;
/**
 * APP-268 (Tom, 2026-11-02: "manager decides, keep it as built"): the one route a new nomination
 * takes. The committee recommends, then the colleague's manager approves or declines. It's no
 * longer a choice in Settings. A nomination already sent keeps the route saved with it, so
 * `committee_only` stays readable here and keeps working for that nomination.
 */
export const SPOT_NEW_NOMINATION_ROUTE = 'committee_then_supervisor' satisfies SpotApprovalMode;
export const LEGACY_SPOT_REVIEW_POLICY: SpotReviewPolicy = {
  approvalMode: SPOT_NEW_NOMINATION_ROUTE,
  cashRange: LEGACY_SPOT_CASH_RANGE,
  settingRowId: null,
};
